import {
  useMediaStreamSetToPointsMutation,
  StreamPureSetToCompanyPointsMutationInput,
} from '@shared/api/graphql/generated';
import { BaseMutationResultType, FetchPolicyKeys } from '@shared/api/graphql/types';

export type StreamSetToPointsResultType = BaseMutationResultType;

export type UseStreamSetToPointsType = [
  request: (input: StreamPureSetToCompanyPointsMutationInput) => Promise<boolean>,
  result: StreamSetToPointsResultType,
];

const useStreamSetToPoints = (): UseStreamSetToPointsType => {
  const [setMutation, setMutationResult] = useMediaStreamSetToPointsMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (input: StreamPureSetToCompanyPointsMutationInput) => {
    const result = await setMutation({
      variables: {
        input,
      },
    });

    return !!result.data?.result?.ok;
  };

  const result: StreamSetToPointsResultType = {
    error: setMutationResult.error,
    loading: setMutationResult.loading,
    called: setMutationResult.called,
  };

  return [request, result];
};

export default useStreamSetToPoints;
